export default __webpack_public_path__ + "static/media/info-img.f943d72e.svg";